'use client';

import { useEffect, useState } from 'react';
import type { CuratedCourseWiki } from '@/app/courses/courseWikiTypes';
import { normalizeExploreCourseId } from './courseWorkspace';

export type CourseWikiPayloadState = { state: 'loading' | 'ready' | 'absent' | 'error'; wiki: CuratedCourseWiki | null; error?: string };
export function useCourseWikiPayload(courseId: string, enabled = true): CourseWikiPayloadState {
  const [result, setResult] = useState<CourseWikiPayloadState>({ state: 'loading', wiki: null });
  useEffect(() => {
    if (!enabled) return;
    const baseId = normalizeExploreCourseId(courseId);
    if (!baseId) { setResult({ state: 'absent', wiki: null }); return; }
    const controller = new AbortController();
    setResult({ state: 'loading', wiki: null });
    fetch(`/api/explore/course/${baseId}`, { signal: controller.signal })
      .then(async (response) => { if (!response.ok) throw new Error(`Course guide request failed (${response.status})`); return response.json() as Promise<{ wiki: CuratedCourseWiki | null }>; })
      .then(({ wiki }) => { if (!controller.signal.aborted) setResult(wiki ? { state: 'ready', wiki } : { state: 'absent', wiki: null }); })
      .catch((error: unknown) => { if (!controller.signal.aborted) setResult({ state: 'error', wiki: null, error: error instanceof Error ? error.message : 'Course guide could not load.' }); });
    return () => controller.abort();
  }, [courseId, enabled]);
  return result;
}
